// Point de passage unique pour toute valeur d'environnement. Les variables REACT_APP_* sont
// injectées par CRA AU BUILD (.env.production / .env.development) — comme environment.prod.ts
// côté sipconfection-frontend, ce ne sont pas des valeurs relues à l'exécution.
export const KEYCLOAK_URL = process.env.REACT_APP_KEYCLOAK_URL || 'https://auth.bicadev.com';
export const KEYCLOAK_REALM = process.env.REACT_APP_KEYCLOAK_REALM || 'sip-realm';
export const KEYCLOAK_CLIENT_ID = process.env.REACT_APP_KEYCLOAK_CLIENT_ID || 'audit-quality-spa';

export const API_URL = process.env.REACT_APP_API_URL || 'https://app.bicadev.com/api/';

export const TOKEN_ENDPOINT =
  `${KEYCLOAK_URL}/realms/${KEYCLOAK_REALM}/protocol/openid-connect/token`;

// Clés localStorage. Préfixées pour ne jamais entrer en collision avec une autre PWA SIP
// installée sur la même tablette (sip-rouleau-scan, etc.).
export const STORAGE_TOKENS = 'aqs.auth.tokens';
export const STORAGE_QUEUE_DB = 'aqs-offline-queue';
